var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var ensureExistence = (scopeName, key) => {
	var scope = __webpack_require__.S[scopeName];
	if(!scope || !__webpack_require__.o(scope, key)) throw new Error("Shared module " + key + " doesn't exist in shared scope " + scopeName);
	return scope;
};
var findVersion = (scope, key) => {
	var versions = scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key) => {
	var versions = scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getSingleton = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	return get(scope[key][version]);
};
var getSingletonVersion = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var getStrictSingletonVersion = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) throw new Error(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var findValidVersion = (scope, key, requiredVersion) => {
	var versions = scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ") of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var getValidVersion = (scope, scopeName, key, requiredVersion) => {
	var entry = findValidVersion(scope, key, requiredVersion);
	if(entry) return get(entry);
	throw new Error(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var warn = (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var warnInvalidVersion = (scope, scopeName, key, requiredVersion) => {
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var init = (fn) => (function(scopeName, a, b, c) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then) return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], a, b, c));
	return fn(scopeName, __webpack_require__.S[scopeName], a, b, c);
});

var load = /*#__PURE__*/ init((scopeName, scope, key) => {
	ensureExistence(scopeName, key);
	return get(findVersion(scope, key));
});
var loadFallback = /*#__PURE__*/ init((scopeName, scope, key, fallback) => {
	return scope && __webpack_require__.o(scope, key) ? get(findVersion(scope, key)) : fallback();
});
var loadVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key) => {
	ensureExistence(scopeName, key);
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getValidVersion(scope, scopeName, key, version);
});
var loadStrictSingletonVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var loadVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingletonFallback = /*#__PURE__*/ init((scopeName, scope, key, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	var entry = scope && __webpack_require__.o(scope, key) && findValidVersion(scope, key, version);
	return entry ? get(entry) : fallback();
});
var loadStrictSingletonVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var installedModules = {};
var moduleToHandlerMapping = {
	142: () => (loadSingletonVersionCheckFallback("default", "@angular/core", [4,17,3,12], () => (__webpack_require__.e(7580).then(() => (() => (__webpack_require__(7580))))))),
	2796: () => (loadSingletonVersionCheckFallback("default", "@angular/common", [4,17,3,12], () => (__webpack_require__.e(316).then(() => (() => (__webpack_require__(316))))))),
	5482: () => (loadSingletonVersionCheckFallback("default", "@angular/core/primitives/signals", [4,17,3,12], () => (__webpack_require__.e(5689).then(() => (() => (__webpack_require__(5689))))))),
	8634: () => (loadSingletonVersionCheckFallback("default", "@angular/common/http", [4,17,3,12], () => (Promise.all([__webpack_require__.e(1965), __webpack_require__.e(2796), __webpack_require__.e(6443)]).then(() => (() => (__webpack_require__(6443))))))),
	1042: () => (loadSingletonVersionCheckFallback("default", "@angular/core/rxjs-interop", [4,17,3,12], () => (Promise.all([__webpack_require__.e(2076), __webpack_require__.e(3900)]).then(() => (() => (__webpack_require__(9074))))))),
	3713: () => (loadFallback("default", "@mijnns/app-config", () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(9838))))))),
	1738: () => (loadStrictSingletonVersionCheckFallback("default", "@jsverse/transloco", [1,7,5,1], () => (Promise.all([__webpack_require__.e(1965), __webpack_require__.e(6959)]).then(() => (() => (__webpack_require__(6959))))))),
	2756: () => (loadFallback("default", "@mijnns/local-storage", () => (Promise.all([__webpack_require__.e(2076), __webpack_require__.e(4800)]).then(() => (() => (__webpack_require__(329))))))),
	5220: () => (loadFallback("default", "@mijnns/device", () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(8530))))))),
	3508: () => (loadFallback("default", "@mijnns/session-storage", () => (__webpack_require__.e(5736).then(() => (() => (__webpack_require__(5736))))))),
	7336: () => (loadSingletonVersionCheckFallback("default", "@angular/router", [4,17,3,12], () => (Promise.all([__webpack_require__.e(1965), __webpack_require__.e(2796), __webpack_require__.e(9804), __webpack_require__.e(4066), __webpack_require__.e(4242)]).then(() => (() => (__webpack_require__(8181))))))),
	1661: () => (loadFallback("default", "@package", () => (__webpack_require__.e(8330).then(() => (() => (__webpack_require__(8330))))))),
	4744: () => (loadFallback("default", "@mijnns/window", () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(2391))))))),
	64: () => (loadFallback("default", "@mijnns/translation", () => (__webpack_require__.e(6032).then(() => (() => (__webpack_require__(6032))))))),
	960: () => (loadFallback("default", "@mijnns/interceptors", () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(7609))))))),
	7283: () => (loadFallback("default", "@mijnns/sentry", () => (__webpack_require__.e(6048).then(() => (() => (__webpack_require__(6048))))))),
	8812: () => (loadFallback("default", "@mijnns/product-service", () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(144))))))),
	9439: () => (loadStrictVersionCheckFallback("default", "@ns/ngx-idp-authentication", [1,10,0,0], () => (__webpack_require__.e(3478).then(() => (() => (__webpack_require__(3478))))))),
	6645: () => (loadFallback("default", "@mijnns/avo", () => (__webpack_require__.e(5013).then(() => (() => (__webpack_require__(5013))))))),
	9130: () => (loadFallback("default", "@mijnns/assets", () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(4942))))))),
	341: () => (loadFallback("default", "@mijnns/ns-data-queue", () => (__webpack_require__.e(1876).then(() => (() => (__webpack_require__(1876))))))),
	2980: () => (loadFallback("default", "@mijnns/nessie", () => (__webpack_require__.e(9778).then(() => (() => (__webpack_require__(9778))))))),
	8006: () => (loadFallback("default", "@mijnns/shared/title-resolver", () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(9758)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"142": [
		142
	],
	"1738": [
		1738
	],
	"2720": [
		6645,
		9130,
		341,
		2980,
		8006
	],
	"2796": [
		2796
	],
	"3713": [
		3713
	],
	"5013": [
		2756
	],
	"6032": [
		4744
	],
	"6048": [
		1661
	],
	"6959": [
		1042
	],
	"7336": [
		7336
	],
	"7580": [
		5482
	],
	"7621": [
		64,
		960,
		7283,
		8812,
		9439
	],
	"8634": [
		8634
	],
	"9451": [
		5220,
		3508
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
		});
	}
}